module.exports = __webpack_public_path__ + "img/banner01.09fa98f6.png";